module.exports = __webpack_public_path__ + "69dcd7463c0216a9541ffcff72f62969.png";